/**
 * The "why" of a write, written for the person instead of by them.
 *
 * Every write the gateway accepts carries a `reason` (doc 25 §3) and the API
 * refuses one without it: the history must stay readable. Asking a person to
 * type "ho corretto un refuso" forty times a day produced reasons like "x" and
 * ".", which is exactly the unreadable history the rule exists to prevent. So
 * the interface writes a real sentence from what actually changed ("Modifiche
 * ai campi «Titolo» e «Corpo» da Migliore CMS") and the person may replace it
 * in the collapsible "Nota per lo storico" when there is something to add.
 */

export type Translate = (key: string, vars?: Record<string, string | number>) => string

/** The sentence for a set of changed fields, by their human labels. */
export function fieldChangeReason(t: Translate, labels: readonly string[]): string {
  const unique = [...new Set(labels.map((label) => label.trim()).filter(Boolean))]
  const [a, b, c] = unique
  if (a === undefined) return t('reason.fields.none')
  if (b === undefined) return t('reason.fields.one', { a })
  if (c === undefined) return t('reason.fields.two', { a, b })
  if (unique.length === 3) return t('reason.fields.three', { a, b, c })
  return t('reason.fields.many', { a, b, count: unique.length })
}

/** What the person wrote, or the prepared sentence when they left the note empty. */
export function resolveReason(note: string, fallback: string): string {
  const written = note.trim()
  return written || fallback
}
